module.exports = __webpack_public_path__ + "images/057ac25f0bb257fba8b66b9001a66070.svg";